module.exports = "/_next/static/images/invest-1b8ef93e7a64458fd8223f510c41c587.svg";